<span class="reaction">
    @if (standardFacebookReactionsList.includes(reaction.type)) {
        <span>
            <sb-inline-svg
                class="icon fb-emoji vertical-align-middle reaction-icon"
                container="body"
                [ngClass]="{ 'single-emoji': isSingleEmoji }"
                (mouseover)="$event.stopPropagation()"
                [tooltip]="
                    tooltipTextType === reactionTooltipTextType.nameAndSenders
                        ? tooltipHtmlContent
                        : reaction.tooltipText || ''
                "
                [url]="'/sb-tools/theme/images/icons/facebook-emoji/' + facebookReactionType[reaction.type] + '.svg'">
            </sb-inline-svg>
            <ng-template #tooltipHtmlContent>
                <div [innerHtml]="reaction.tooltipText | safeHtml"></div>
            </ng-template>
        </span>
    } @else {
        <span
            class="icon emoji-icon reaction-icon"
            [ngClass]="{ 'single-emoji': isSingleEmoji }"
            [innerHTML]="reaction.emoji | replaceEmojis: false : true"
            [tooltip]="reaction.tooltipText || ''"
            container="body"
            (mouseover)="$event.stopPropagation()">
        </span>
    }
    @if (isShowReactionCount) {
        <span class="ms-1 vertical-align-middle">
            {{ reaction.count }}
        </span>
    }
</span>
